export default "__VITE_ASSET__DQt7p_i8__"